import { productsCategories } from 'constants/products';

export const consultationProductsCategories = [
  productsCategories.HAIRCARE,
  productsCategories.SKINCARE,
];

export const { HAIRCARE, SKINCARE } = productsCategories;
